/* Primary-menu dropdown (partials/components/navigation.hbs, assets/css/crpg/nav-dropdown.css).
   Hover and keyboard focus open it through CSS; this adds click/tap, Escape and click-outside.
   Delegated from document on purpose: dropdown.js restores the menu's innerHTML on resize, which
   would drop listeners bound to the buttons themselves. */
(function () {
    function closeAll(except) {
        document.querySelectorAll('.crpg-has-sub.is-open').forEach(function (item) {
            if (item === except) return;
            item.classList.remove('is-open');
            const btn = item.querySelector('.crpg-sub-toggle');
            if (btn) btn.setAttribute('aria-expanded', 'false');
        });
    }

    document.addEventListener('click', function (event) {
        const btn = event.target.closest('.crpg-sub-toggle');
        if (!btn) {
            if (!event.target.closest('.crpg-sub')) closeAll(null);
            return;
        }
        const item = btn.closest('.crpg-has-sub');
        closeAll(item);
        const open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        const open = document.querySelector('.crpg-has-sub.is-open, .crpg-has-sub:focus-within');
        closeAll(null);
        if (open) {
            const btn = open.querySelector('.crpg-sub-toggle');
            if (btn) btn.focus();
        }
    });
})();
